import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  setCurrentSectionName,
  setCurrentSong,
  setCurrentSongIndex,
  setCurrentSongName,
  setDefaultMt,
  setGhostTonesMT,
  setNewSectionModal,
  setShowGhost,
  setSongModal,
  setSongsArray,
  setTonesMT,
  setUserGhost,
} from "../../store/actions";
import PopupMusicTheorySong from "./popupMusicTheorySong";
import AddNewSong from "./addNewSong";
import AddNewSection from "./addNewSection";
import { NOTES } from "../../helpers/pianoHelpers";

function SongsWindow(props) {
  const mainScales = [
    "Major Melodic",
    "Major Harmonic",
    "Minor Harmonic",
    "Minor Melodic",
  ];
  const sidebarRef = useRef();
  const sidebarContentRef = useRef();
  const [openMusicTheoryPopup, setOpenMusicTheoryPopup] = useState(false);
  const [currentSong, setCurrentSong] = useState("");
  const [editFormula, setEditFormula] = useState("");
  const [editFormulaIndex, setEditFormulaIndex] = useState("");
  const [editSong, setEditSong] = useState("");
  const [editSection, setEditSection] = useState("");

  const handleWindowClose = () => {
    sidebarRef.current.style.right = "-391px";
    document.querySelector(".container-wrapper").style.marginRight = "0px";
  };

  const handleAddNewSong = () => {
    handleNewSongModal();
  };

  const handleAddFormula = (section) => {
    props.setCurrentSectionName(section);
    setEditFormulaIndex("");
    setEditFormula("");
    handleToggleModal();
  };

  const handleToggleModal = () => {
    setOpenMusicTheoryPopup(!openMusicTheoryPopup);
  };

  const handleNewSongModal = () => {
    setEditSong("");
    props.setSongModal(!props.openNewSongModal);
  };

  const handleEditFormula = (songName, section, songIndex) => {
    setCurrentSong(songName);
    props.setCurrentSectionName(section);
    setEditFormula(props.songsArray[songName][section][songIndex]);
    setEditFormulaIndex(songIndex);
    handleToggleModal();
  };

  const handleDeleteFormula = (songName, section, songIndex) => {
    const updatedSongs = { ...props.songsArray };
    updatedSongs[songName][section].splice(songIndex, 1);
    if (songIndex === props.currentSongIndex) {
      if (
        updatedSongs[props.currentSongName][section][props.currentSongIndex]
      ) {
        props.setTonesMT(
          updatedSongs[props.currentSongName][section][props.currentSongIndex]
        );
        props.setCurrentSongIndex(props.currentSongIndex);

        if (updatedSongs[props.currentSongName][section][songIndex + 1]) {
          props.setGhostTonesMT(
            updatedSongs[props.currentSongName][section][songIndex + 1]
          );
        } else {
          props.setGhostTonesMT(
            updatedSongs[props.currentSongName][section][0]
          );
        }
      } else {
        props.setTonesMT(updatedSongs[props.currentSongName][section][0]);
        props.setCurrentSongIndex(0);
        if (updatedSongs[props.currentSongName][section][1]) {
          props.setGhostTonesMT(
            updatedSongs[props.currentSongName][section][1]
          );
        } else {
          props.setGhostTonesMT("");
        }
      }
    } else {
      if (
        updatedSongs[props.currentSongName][section][props.currentSongIndex + 1]
      ) {
        props.setGhostTonesMT(
          updatedSongs[props.currentSongName][section][
            props.currentSongIndex + 1
          ]
        );
      } else {
        props.setGhostTonesMT(updatedSongs[props.currentSongName][section][0]);
      }
    }

    if (updatedSongs[songName].length === 0) {
      delete updatedSongs[songName];
      props.setEnableMusicTheory(false);
      props.setGhostTonesMT("");
      props.setCurrentSongName("");
      props.setCurrentSongIndex("");
      props.setTonesMT("");
    }
    props.setSongsArray(updatedSongs);
  };

  const handleFormulaChange = (e, songName, section, songIndex) => {
    e.preventDefault();
    props.setEnableMusicTheory(true);
    props.setCurrentSong(songName);
    props.setCurrentSongName(songName);
    props.setCurrentSectionName(section);
    props.setCurrentSongIndex(songIndex);
    props.setTonesMT(props.songsArray[songName][section][songIndex]);
    props.setDefaultMt(props.songsArray[songName][section][songIndex]);
    if (props.songsArray[songName][section].length > 1) {
      if (props.songsArray[songName][section][songIndex + 1]) {
        props.setGhostTonesMT(
          props.songsArray[songName][section][songIndex + 1]
        );
      } else {
        props.setGhostTonesMT(props.songsArray[songName][section][0]);
      }
    } else {
      props.setGhostTonesMT("");
    }
    if (props.userGhost) {
      props.setShowGhost(true);
    }
  };

  const handleBackButton = () => {
    props.setCurrentSongName("");
    props.setCurrentSongIndex("");
    props.setShowGhost(false);
    props.setGhostTonesMT("");
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const songName = props.currentSongName;
    debugger;
    // Check if dragging within the same section or across sections
    const sourceSection = source.droppableId.replace("formulas-", "");
    const destinationSection = destination.droppableId.replace("formulas-", "");
    const isSameSection = sourceSection === destinationSection;

    const sourceItems = Array.from(props.songsArray[songName][sourceSection]);
    const destinationItems = isSameSection
      ? sourceItems
      : Array.from(props.songsArray[songName][destinationSection]);

    // Move the song within the source section or across to the destination section
    const [movedItem] = sourceItems.splice(source.index, 1);
    destinationItems.splice(destination.index, 0, movedItem);

    // Update the songsArray state with reordered items
    const updatedSection = {
      ...props.songsArray[songName],
      [sourceSection]: sourceItems,
      [destinationSection]: destinationItems,
    };
    const updatedSongsArray = {
      ...props.songsArray,
      [songName]: updatedSection,
    };

    // Update state only if the item is moved
    let updatedSongIndex = props.currentSongIndex;
    let updatedSectionName = props.currentSectionName;

    if (
      (updatedSongIndex !== "" && sourceSection === props.currentSectionName) ||
      destinationSection === props.currentSectionName
    ) {
      if (sourceSection === props.currentSectionName) {
        if (source.index == props.currentSongIndex) {
          updatedSongIndex = destination.index;
          updatedSectionName = destinationSection;
        } else if (
          source.index < props.currentSongIndex &&
          destination.index >= props.currentSongIndex
        ) {
          updatedSongIndex -= 1;
        } else if (
          destination.index == props.currentSongIndex &&
          destinationSection == props.currentSectionName
        ) {
          updatedSongIndex = props.currentSongIndex + 1;
        }

        props.setTonesMT(
          updatedSongsArray[props.currentSongName][updatedSectionName][
            updatedSongIndex
          ]
        );
        props.setGhostTonesMT(
          updatedSongsArray[props.currentSongName][updatedSectionName][
            updatedSongIndex + 1
          ] || updatedSongsArray[props.currentSongName][updatedSectionName][0]
        );

        props.setCurrentSongIndex(updatedSongIndex);
        props.setCurrentSectionName(updatedSectionName);
      } else {
        if (destination.index <= props.currentSongIndex) {
          updatedSongIndex += 1;
        }
        props.setTonesMT(
          updatedSongsArray[props.currentSongName][updatedSectionName][
            updatedSongIndex
          ]
        );
        props.setGhostTonesMT(
          updatedSongsArray[props.currentSongName][updatedSectionName][
            updatedSongIndex + 1
          ] || updatedSongsArray[props.currentSongName][updatedSectionName][0]
        );

        props.setCurrentSongIndex(updatedSongIndex);
        props.setCurrentSectionName(updatedSectionName);
      }
    }

    props.setSongsArray(updatedSongsArray);
  };

  const handleShowGhost = () => {
    props.setShowGhost(!props.showGhost);
    props.setUserGhost(!props.showGhost);
  };
  const handleDeleteSong = (songName) => {
    // Remove the song from the songsArray
    const updatedSongsArray = { ...props.songsArray };
    delete updatedSongsArray[songName];

    // Pass the updated songsArray to the parent component
    props.setSongsArray(updatedSongsArray);
  };
  const handleEditSong = (songName) => {
    handleAddNewSong();
    setEditSong(songName);
  };
  const handleAddSection = () => {
    props.setNewSectionModal(!props.openNewSectionModal);
  };
  const getNoteLabel = (note, modeValue) => {
    if (note == "D♭/C♯") {
      return modeValue == 0 || modeValue == 1 ? "D♭" : "C♯";
    }
    if (note == "A♭/G♯") {
      return modeValue == 0 || modeValue == 1 ? "A♭" : "G♯";
    }
    return note;
  };
  const handleEditSection = (sectionName) => {
    setEditSection(sectionName);
    handleAddSection();
  };

  const handleDeleteSection = (sectionName) => {
    let songArray = { ...props.songsArray };
    const sectionsArray = { ...songArray[props.currentSongName] };
    delete sectionsArray[sectionName];
    songArray[props.currentSongName] = sectionsArray;
    props.setSongsArray(songArray);
  };

  function duplicateSection(currentSectionName) {
    const { songsArray, currentSongName, setSongsArray } = props;

    // Ensure the current section exists
    if (
      !songsArray[currentSongName] ||
      !songsArray[currentSongName][currentSectionName]
    ) {
      console.error("Section not found!");
      return;
    }

    // Get the original section to duplicate
    const originalSection = songsArray[currentSongName][currentSectionName];

    // Duplicate the section
    const duplicatedSection = JSON.parse(JSON.stringify(originalSection));
    const duplicateName = `${currentSectionName}_Copy`;

    // Get the current song object and create a new object to avoid mutation
    const songSections = songsArray[currentSongName];
    const sectionEntries = Object.entries(songSections);

    // Prepare a new sections object with the duplicated section
    const updatedSectionEntries = [];
    for (let i = 0; i < sectionEntries.length; i++) {
      const [sectionName, sectionContent] = sectionEntries[i];

      // Add the current section
      updatedSectionEntries.push([sectionName, sectionContent]);

      // Add the duplicated section right after the original
      if (sectionName === currentSectionName) {
        updatedSectionEntries.push([duplicateName, duplicatedSection]);
      }
    }

    // Convert the updated sections back to an object
    const updatedSongSections = Object.fromEntries(updatedSectionEntries);

    // Create a new songs array object with the updated sections
    const updatedSongsArray = {
      ...songsArray,
      [currentSongName]: updatedSongSections,
    };

    // Update the state with the new songs array
    setSongsArray(updatedSongsArray);
  }

  return (
    <div>
      <div className="menu" ref={sidebarRef}>
        <div ref={sidebarContentRef} className="sidebar-content">
          <button className="close" onClick={handleWindowClose}>
            <i className="fa fa-close"></i>
          </button>
          {props.currentSongName === "" ? (
            <>
              <button
                className="btn btn_primary w-100 mb-4"
                onClick={handleAddNewSong}
              >
                <i className="fa fa-plus"></i> Add Song
              </button>
              {props.songsArray &&
                Object.keys(props.songsArray).map((songName, groupIndex) => (
                  <div
                    key={groupIndex}
                    className="align-items-center d-flex justify-content-between text-capitalize song-container"
                  >
                    <strong
                      className="col-10"
                      onClick={() => props.setCurrentSongName(songName)}
                    >
                      {songName}
                    </strong>
                    <button
                      className="btn edit-btn col-1 mr-2"
                      onClick={() => handleEditSong(songName)}
                    >
                      <i className="fa fa-edit"></i>
                    </button>
                    <button
                      className="btn delete-btn col-1"
                      onClick={() => handleDeleteSong(songName)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                ))}
            </>
          ) : (
            <>
              <div className="d-flex justify-content-between">
                <div className="col-8">
                  <label className="form-label noselect" htmlFor="show-ghost">
                    Show ghost tones
                  </label>
                </div>
                <div className="col-3 settings-group">
                  <input
                    className="settings settings-light"
                    id="show-ghost"
                    type="checkbox"
                    checked={props.showGhost}
                    onChange={handleShowGhost}
                  />
                  <label className="settings-btn" htmlFor="show-ghost"></label>
                </div>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <button className="btn btn_primary" onClick={handleBackButton}>
                  <i className="fa fa-arrow-left"></i>
                </button>
                <button
                  className="btn btn_primary"
                  onClick={(e) => handleAddSection(e, props.currentSongName)}
                >
                  <i className="fa fa-plus"></i> Add Section
                </button>
              </div>
              <div className="mb-1 text-capitalize">
                <strong
                  className="song-name-tooltip text-center text-truncate"
                  title={`${props.currentSongName} - ${
                    props.songsArray[props.currentSongName]["artist"][0]
                  }`}
                >
                  {props.currentSongName} -{" "}
                  {props.songsArray[props.currentSongName]["artist"][0]}
                </strong>
              </div>

              <DragDropContext onDragEnd={handleDragEnd}>
                {Object.keys(props.songsArray[props.currentSongName]).map(
                  (sectionName, sectionIndex) =>
                    sectionName !== "artist" && (
                      <div
                        key={sectionIndex}
                        className="section-container mb-3"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>{sectionName}</strong>
                          <div className="d-flex justify-content-between">
                            <button
                              className="btn edit-btn col-1 mr-1"
                              onClick={() => handleEditSection(sectionName)}
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              className="btn delete-btn col-1 mr-1"
                              onClick={() => handleDeleteSection(sectionName)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                            <button
                              className="btn edit-btn col-1 mr-1"
                              onClick={() => duplicateSection(sectionName)}
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                            <button
                              className="btn btn_primary"
                              onClick={() => handleAddFormula(sectionName)}
                            >
                              <i className="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>

                        <Droppable droppableId={`formulas-${sectionName}`}>
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {props.songsArray[props.currentSongName][
                                sectionName
                              ].map((song, index) => (
                                <Draggable
                                  key={`${sectionName}-${index}`} // Unique key per item
                                  draggableId={`${sectionName}-${index}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className={`align-items-center d-flex formula-container justify-content-between mb-2 ${
                                        props.currentSongIndex === index
                                          ? "formula-container-hover"
                                          : ""
                                      }`}
                                    >
                                      <div
                                        className="flex-grow-1 formula-name"
                                        onClick={(e) =>
                                          handleFormulaChange(
                                            e,
                                            props.currentSongName,
                                            sectionName,
                                            index
                                          )
                                        }
                                      >
                                        <span
                                          className={`selected-song ${
                                            props.currentSongIndex === index &&
                                            props.currentSectionName ===
                                              sectionName
                                              ? "pie"
                                              : ""
                                          }`}
                                        ></span>
                                        <span>
                                          {getNoteLabel(
                                            song.note,
                                            song.modesOfScalesValues.y
                                          )}{" "}
                                        </span>{" "}
                                        <span
                                          style={{
                                            color:
                                              song.modesOfScalesValues
                                                .nameColor || "#fff",
                                          }}
                                        >
                                          {song.modesOfScalesValues.name}
                                        </span>{" "}
                                        <span
                                          style={{
                                            color:
                                              song.modesOfScalesValues
                                                .degreeColor,
                                          }}
                                        >
                                          {song.modesOfScalesValues.degree}
                                        </span>{" "}
                                        <span
                                          style={{
                                            color:
                                              song.modesOfScalesValues
                                                .secondDegreeColor,
                                          }}
                                        >
                                          {song.modesOfScalesValues
                                            .secondDegree || ""}
                                        </span>{" "}
                                        <span style={{ color: "#fff" }}>
                                          {song.modesOfScalesValues
                                            .chromaticFormula
                                            ? " + Chrom"
                                            : ""}
                                        </span>
                                        <span className="main-scale">
                                          {song.modesOfScalesValues.numbers
                                            .length === 7 &&
                                            mainScales[
                                              song.modesOfScalesValues
                                                .mainScaleIndex
                                            ]}
                                        </span>
                                      </div>
                                      <div>
                                        <button
                                          className="btn edit-btn"
                                          onClick={() =>
                                            handleEditFormula(
                                              props.currentSongName,
                                              sectionName,
                                              index
                                            )
                                          }
                                        >
                                          <i className="fa fa-edit"></i>
                                        </button>
                                        <button
                                          className="btn delete-btn"
                                          onClick={() =>
                                            handleDeleteFormula(
                                              props.currentSongName,
                                              sectionName,
                                              index
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    )
                )}
              </DragDropContext>
            </>
          )}
        </div>
      </div>

      {openMusicTheoryPopup && (
        <PopupMusicTheorySong
          toggleModal={handleToggleModal}
          show={openMusicTheoryPopup}
          songName={props.currentSongName}
          editFormula={editFormula}
          setEditFormula={setEditFormula}
          editFormulaIndex={editFormulaIndex}
        />
      )}
      {props.openNewSongModal && (
        <AddNewSong
          toggleModal={handleAddNewSong}
          show={props.openNewSongModal}
          editSong={editSong}
          setEditSong={setEditSong}
        />
      )}
      {props.openNewSectionModal && (
        <AddNewSection
          toggleModal={handleAddSection}
          show={props.openNewSectionModal}
          editSection={editSection}
          setEditSection={setEditSection}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    songsArray: state.songsArray,
    openNewSongModal: state.openNewSongModal,
    applyGhost: state.applyGhost,
    currentSong: state.currentSong,
    currentSongIndex: state.currentSongIndex,
    currentSongName: state.currentSongName,
    showGhost: state.showGhost,
    userGhost: state.userGhost,
    openNewSectionModal: state.openNewSectionModal,
    currentSectionName: state.currentSectionName,
    baseNote: state.baseNote,
  };
};

const mapDispatchToProps = {
  setSongsArray,
  setSongModal,
  setTonesMT,
  setGhostTonesMT,
  setCurrentSong,
  setCurrentSongName,
  setCurrentSongIndex,
  setShowGhost,
  setUserGhost,
  setNewSectionModal,
  setCurrentSectionName,
  setDefaultMt,
};

export default connect(mapStateToProps, mapDispatchToProps)(SongsWindow);
